import React from 'react';

import * as D from '../../deps';

interface IListenerCountSubtitleLargeProps {
  stationListenerCount?: number;
}

const ListenerCountSubtitleLarge = React.memo((props: IListenerCountSubtitleLargeProps) => {
  const { stationListenerCount } = props;
  if (stationListenerCount === 0) {
    return null;
  }
  return D.getInDomain('catalog.utils.displayMonthlyListenerCount', 0)(stationListenerCount, true);
});

export default ListenerCountSubtitleLarge;
